import { gql } from "apollo-boost";

export const ADD_STUDENTUNITTEST = gql`
  mutation addStudentUnitTest(
    $studentUnitTestInput: StudentUnitTestInput!
    $studentId: ID!
    $studentEnrollId: ID!
    $studentEnrollDetailId: ID!
    $academicPeriodId: ID!
    $subjectId: ID!
    $courseOutlineUnitId: ID
  ) {
    addStudentUnitTest (
      studentUnitTestInput: $studentUnitTestInput,
      studentId: $studentId,
      studentEnrollId: $studentEnrollId,
      studentEnrollDetailId: $studentEnrollDetailId,
      academicPeriodId: $academicPeriodId,
      subjectId: $subjectId,
      courseOutlineUnitId: $courseOutlineUnitId,
    )
    {
      id
      unitSeq
      isPosttestDone
      pretestMaxScore
      pretestQuestionQty
      pretestScore
      isPretestDone
      posttestMaxScore
      posttestQuestionQty
      posttestScore
      isPosttestDone
    }
  }
`;

export const GET_STUDENT_UNITPRETEST_BYFILTER = gql`
  query getStudentUnitPretestsByFilter (
    $studentUnitTestId: ID!
  ) {
    getStudentUnitPretestsByFilter (
      studentUnitTestId: $studentUnitTestId
    )
    {
      id
      studentUnitTest {
        id
      }
      examQuestion {
        id
        unitSeq
        nameLocal
        nameEng
        picturePath
        score
        isRandomChoice
        examAnswers {
          id
          no
          isCorrected
          nameLocal
          nameEng
          picturePath
        }
      }
      studentUnitPretestAnswer {
        id
        answerNo
        answerSeq
      }
      studentUnitAnswerNo
      isDone
    }
  }
`;

export const GENERATE_STUDENT_UNITPRETESTS = gql`
  mutation generateStudentUnitPretests (
    $studentUnitTestId: ID!
    $studentEnrollDetailId: ID!
    $courseOutlineUnitId: ID!
  ) {
    generateStudentUnitPretests (
      studentUnitTestId: $studentUnitTestId,
      studentEnrollDetailId: $studentEnrollDetailId,
      courseOutlineUnitId: $courseOutlineUnitId
    )
    {
      id
      studentUnitTest {
        id
      }
      examQuestion {
        id
        unitSeq
        nameLocal
        nameEng
        picturePath
        score
        isRandomChoice
        examAnswers {
          id
          no
          isCorrected
          nameLocal
          nameEng
          picturePath
        }
      }
      studentUnitPretestAnswer {
        id
        answerNo
        answerSeq
      }
      studentUnitAnswerNo
      isDone
    }
  }
`;

export const BULKCREATE_STUDENTUNIT_PRETEST_ANSWER = gql`
  mutation bulkCreateStudentUnitPretestAnswer (
    $studentUnitPretestAnswerCreateArray: [StudentUnitPretestAnswerBulkCreateInput!]
  ) {
    bulkCreateStudentUnitPretestAnswer(
      studentUnitPretestAnswerCreateArray: $studentUnitPretestAnswerCreateArray
    )
    {
      id
      pretestMaxScore pretestQuestionQty pretestScore isPretestDone
      posttestMaxScore posttestQuestionQty posttestScore isPosttestDone
      courseOutlineUnit { id }
    }
  }
`;



export const GET_STUDENT_UNITPOSTTEST_BYFILTER = gql`
query getStudentUnitPosttestsByFilter (
  $studentUnitTestId: ID!
) {
  getStudentUnitPosttestsByFilter (
    studentUnitTestId: $studentUnitTestId
  )
  {
    id
    studentUnitTest {
      id
    }
    examQuestion {
      id
      unitSeq
      nameLocal
      nameEng
      picturePath
      score
      isRandomChoice
      examAnswers {
        id
        no
        isCorrected
        nameLocal
        nameEng
        picturePath
      }
    }
    studentUnitPosttestAnswer {
      id
      answerNo
      answerSeq
    }
    studentUnitAnswerNo
    isDone
  }
}
`;

export const GENERATE_STUDENT_UNITPOSTTESTS = gql`
mutation generateStudentUnitPosttests (
  $studentUnitTestId: ID!
  $studentEnrollDetailId: ID!
  $courseOutlineUnitId: ID!
) {
  generateStudentUnitPosttests (
    studentUnitTestId: $studentUnitTestId,
    studentEnrollDetailId: $studentEnrollDetailId,
    courseOutlineUnitId: $courseOutlineUnitId
  )
  {
    id
    studentUnitTest {
      id
    }
    examQuestion {
      id
      unitSeq
      nameLocal
      nameEng
      picturePath
      score
      isRandomChoice
      examAnswers {
        id
        no
        isCorrected
        nameLocal
        nameEng
        picturePath
      }
    }
    studentUnitPosttestAnswer {
      id
      answerNo
      answerSeq
    }
    studentUnitAnswerNo
    isDone
  }
}
`;

export const BULKCREATE_STUDENTUNIT_POSTTEST_ANSWER = gql`
  mutation bulkCreateStudentUnitPosttestAnswer (
    $studentUnitPosttestAnswerCreateArray: [StudentUnitPosttestAnswerBulkCreateInput!]
  ) {
    bulkCreateStudentUnitPosttestAnswer(
      studentUnitPosttestAnswerCreateArray: $studentUnitPosttestAnswerCreateArray
    )
    {
      id
      pretestMaxScore pretestQuestionQty pretestScore isPretestDone
      posttestMaxScore posttestQuestionQty posttestScore isPosttestDone
      courseOutlineUnit { id }
    }
  }
`;

export const UPDATE_STUDENTUNIT_TEST = gql`
  mutation updateStudentUnitTest (
    $id: ID!
    $isPretestDone: Boolean
    $isPosttestDone: Boolean
  ) {
    updateStudentUnitTest(
      id: $id
      isPretestDone: $isPretestDone
      isPosttestDone: $isPosttestDone
    )
    {
      id
    }
  }
`;
